export default function ProgressBar({ value, className = 'h-3', track = 'bg-track' }) {
  const pct = Math.max(0, Math.min(100, value ?? 0))
  return (
    <div
      className={`overflow-hidden rounded-full ${track} ${className}`}
      role="progressbar"
      aria-valuenow={Math.round(pct)}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div className="h-full rounded-full bg-teal-soft transition-[width]" style={{ width: `${pct}%` }} />
    </div>
  )
}
